@if (tabsContent$ | async; as tabsContent) {
  <ul
    ngbNav
    #nav="ngbNav"
    [(activeId)]="active"
    class="nav-tabs"
    [destroyOnHide]="false"
    >
    @for (
      tabContent of tabsContent; track trackByTabsContent($index,
      tabContent); let count = $count; let isLast = $last) {
      <li
        [ngbNavItem]="tabContent.index"
        >
        <button ngbNavLink class="nav-link" translate>
          {{ tabContent.title }}
        </button>
        <ng-template ngbNavContent>
          <ng-container *ngComponentOutlet="tabContent.component" />
        </ng-template>
      </li>
    }
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
}
